import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, NavLink } from "react-router-dom";
import logo from "../Assets/blue/milesoft-compact-blue.png";
import {
  faComments,
  faCode,
  faHouse,
  faThLarge,
  faUser
} from "@fortawesome/free-solid-svg-icons";


function NavBar() {
  const navLinkClass = ({ isActive }) => `nav-link${isActive ? " active" : ""}`;

  return (
    <nav className="navbar navbar-expand-lg navbar-light site-navbar">
      <Link to="/" className="navbar-brand" aria-label="MileSoft home">
        <img
          src={logo}
          alt="MileSoft"
          className="site-navbar-logo"
          height="64"
        />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarContent"
      >
        <ul className="navbar-nav me-auto">
          <li className="nav-item">
            <NavLink to="/" className={navLinkClass} end>
              <FontAwesomeIcon icon={faHouse} aria-hidden="true" />
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/about" className={navLinkClass}>
              <FontAwesomeIcon icon={faUser} aria-hidden="true" />
              About Us
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/services" className={navLinkClass}>
              <FontAwesomeIcon icon={faCode} aria-hidden="true" />
              Services
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/portfolio" className={navLinkClass}>
              <FontAwesomeIcon icon={faThLarge} aria-hidden="true" />
              Portfolio
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/contacts" className={navLinkClass}>
              <FontAwesomeIcon icon={faComments} aria-hidden="true" />
              Contacts
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
